import { useQuery } from "@tanstack/react-query";
import { parseSingleParticipant } from "./helpers";

async function getParticipantByParticipantId({
  callApiWithWorker,
  participantId,
  signal,
}) {
  const res = await callApiWithWorker(
    `/participants/${encodeURIComponent(participantId)}`,
    {
      method: "GET",
      signal,
    },
  );

  return parseSingleParticipant(res);
}

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string | undefined | null} deps.participantId
 * @param {boolean | undefined} deps.enabled
 */
export function useGetParticipantByParticipantId({
  callApiWithWorker,
  participantId,
  enabled = true,
}) {
  return useQuery({
    queryKey: ["participants", "byParticipantId", participantId],
    enabled: enabled && !!participantId,
    queryFn: ({ signal } = {}) =>
      getParticipantByParticipantId({
        callApiWithWorker,
        participantId,
        signal,
      }),
    staleTime: 30_000,
  });
}
